const INVESTMENT_GOAL_LABELS = {
  "wealth-growth": "Long-term Wealth Growth",
  retirement: "Retirement Planning",
  income: "Generate Passive Income",
  preservation: "Wealth Preservation",
  education: "Education Planning",
  other: "Other",
};

const PORTFOLIO_SIZE_LABELS = {
  "0-10L": "₹0 – ₹10 Lakhs",
  "10L-50L": "₹10 – ₹50 Lakhs",
  "50L-1Cr": "₹50 Lakhs – ₹1 Crore",
  "1Cr-5Cr": "₹1 – ₹5 Crores",
  "5Cr+": "₹5 Crores+",
};

const line = (label, value) => {
  const v =
    value === undefined || value === null || String(value).trim() === ""
      ? "—"
      : String(value).trim();
  return `${label}: ${v}`;
};

const section = (title, lines) => {
  const body = lines.filter(Boolean).join("\n");
  return body ? `${title}\n${"-".repeat(title.length)}\n${body}` : "";
};

/**
 * @param {{
 *   leadModule: string,
 *   formData: {
 *     name: string,
 *     email: string,
 *     phone: string,
 *     investmentGoal: string,
 *     portfolioSize: string,
 *     time: string,
 *     message: string,
 *   },
 *   selectedDate: Date,
 * }} params
 */
export function formatConsultationInternalComments({
  leadModule,
  formData,
  selectedDate,
}) {
  const formattedDate = selectedDate
    ? selectedDate.toLocaleDateString("en-IN", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "—";

  const goalLabel =
    INVESTMENT_GOAL_LABELS[formData.investmentGoal] ||
    formData.investmentGoal ||
    "—";

  const portfolioLabel =
    PORTFOLIO_SIZE_LABELS[formData.portfolioSize] ||
    formData.portfolioSize ||
    "Not specified";

  const blocks = [
    "Consultation Booking — Wealth Compounders",
    "",
    section("Source", [line("Module", leadModule), line("Form", "Schedule Your Free Consultation")]),
    "",
    section("Contact Details", [
      line("Full Name", formData.name),
      line("Email", formData.email),
      line("Phone", formData.phone),
    ]),
    "",
    section("Investment Profile", [
      line("Primary Investment Goal", goalLabel),
      line("Current Portfolio Size", portfolioLabel),
      line("Additional Information", formData.message || "None provided"),
    ]),
    "",
    section("Preferred Consultation Slot", [
      line("Date", formattedDate),
      line("Time Slot", formData.time),
    ]),
    "",
    section("Submission", [
      line("Submitted At", new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })),
    ]),
  ];

  return blocks.filter((b) => b !== undefined).join("\n");
}

/**
 * @param {{
 *   form: { name: string, email: string, phone: string, subject: string, message: string },
 *   leadModule?: string,
 * }} params
 */
export function formatContactInternalComments({ form, leadModule = "Contact Page" }) {
  const blocks = [
    "Contact Form — Wealth Compounders",
    "",
    section("Source", [line("Module", leadModule), line("Form", "Contact Page")]),
    "",
    section("Contact Details", [
      line("Full Name", form.name),
      line("Email", form.email),
      line("Phone", form.phone || "Not provided"),
    ]),
    "",
    section("Enquiry", [line("Subject", form.subject), line("Message", form.message)]),
    "",
    section("Submission", [
      line("Submitted At", new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })),
    ]),
  ];

  return blocks.join("\n");
}
